import { MobiDocument } from './MobiDocument';

export class Autorisations extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private type: string;
    private intitule: string;
    private texte: string;
    private typeautorisation_id: number;
    private mobi: boolean;


    //Attributs for Vuejs
    private affichageedition: number;


    public constructor(autorisation: any) {
        super();
        this._id = autorisation._id;
        this._rev = autorisation._rev;
        this.id = autorisation.id;
        this.type = autorisation.type;
        this.intitule = autorisation.intitule
        this.texte = autorisation.texte
        this.typeautorisation_id = autorisation.typeautorisation_id;
        this.mobi = autorisation.mobi;
        this.affichageedition = -1

    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getType(): string {
        return this.type;
    }

    public setType(type: string): void {
        this.type = type;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getTexte(): string {
        return this.texte;
    }

    public setTexte(texte: string): void {
        this.texte = texte;
    }

    public getTypeautorisation_id(): number {
        return this.typeautorisation_id;
    }

    public setTypeautorisation_id(typeautorisation_id: number): void {
        this.typeautorisation_id = typeautorisation_id;
    }

    public isMobi(): boolean {
        return this.mobi;
    }

    public setMobi(mobi: boolean): void {
        this.mobi = mobi;
    }

    public getAffichageedition(): number {
        return this.affichageedition;
    }

    public setAffichageedition(affichageedition: number): void {
        this.affichageedition = affichageedition;
    }
}